export default class PendingInvitationsController {
  constructor(AuthService, $state, ContentService, ProfilePermissionsService) {
    this.service = ContentService;
    this.state = $state;
    this.authService = AuthService;
    this.permissionsService = ProfilePermissionsService;
  }

  $onInit() {
    this.subscriptions = [];
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  acceptInvitation(invitation, idx) {
    this.subscriptions.push(
      this.service.acceptInvitation({invitation: invitation}).subscribe(
        resp => {
          this.invitations.splice(idx, 1);
          this.state.go('profileSelection', {invitations: this.invitations});
        },
        resp => {}
      )
    );
  }

  logout() {
    this.subscriptions.push(
      this.authService.logout().subscribe(
        (data) => this.state.go('login'),
        (error) => { }
      )
    );
  }
}

 PendingInvitationsController.$inject = ['AuthService', '$state', 'ContentService', 'ProfilePermissionsService'];


// WEBPACK FOOTER //
// ./src/app/pages/pending-invitations/pending-invitations.controller.js